export default __webpack_public_path__ + "static/media/hero.d2954058.jpg";